import type { ForecastLine } from '../../api/cashReport'

export function sourceFocus(line: ForecastLine): string {
  if (line.focus) return String(line.focus)
  return `${line.source_type}:${line.source_id}`
}

export function sourceHref(line: ForecastLine): string | null {
  if (line.project_id == null || line.source_id == null || !line.source_type) return null
  if (String(line.source_id).startsWith('missing:')) return null
  const params = new URLSearchParams({
    sourceContext: 'cash-report',
    focus: sourceFocus(line),
  })
  if (line.source_type === 'job_cost') params.set('tab', 'costs')
  return `/projects/${line.project_id}?${params.toString()}`
}
